var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lu-table',{ref:"selectTable",attrs:{"data":_vm.tableData},on:{"select":_vm.selectChange,"select-all":_vm.selectAll}},[_c('lu-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }